/**
 * Compare two HTML strings for semantic equivalence by round-tripping
 * each through the browser's parser. Collapses character-encoding
 * differences (e.g. "•" vs "&bull;") that HugeRTE introduces when it
 * re-serializes content, so we don't mark fields dirty just because
 * the editor canonicalized the value we handed it.
 *
 * Ported verbatim from reflex-admin/src/agreements/htmlsEquivalent.ts.
 */
export function htmlsEquivalent(a: string, b: string): boolean {
  if (a === b) return true;
  return canonicalize(a) === canonicalize(b);
}

function canonicalize(html: string): string {
  if (!html) return "";
  // DOMParser, not a detached div: a div's innerHTML assignment still
  // fetches <img src> and fires onerror handlers, so parsing the raw
  // stored value that way executes attacker markup in the portal
  // origin. DOMParser documents are inert — nothing loads or runs.
  const doc = new DOMParser().parseFromString(html, "text/html");
  const body = doc.body;
  const hasText = !!body.textContent?.trim();
  const hasMedia = !!body.querySelector(
    "img,video,iframe,canvas,svg,embed,object,audio",
  );
  if (!hasText && !hasMedia) return "";
  return body.innerHTML;
}
